import { Button, Select } from '../core/controls';
import { Modal, useModalClose } from '../core/ui';
import { accountOrigin } from '../theme';
import type { Appearance } from '../core/appearance';
import type { Layout } from './home';
import type { HomeContext } from './HomeHeader';

export function HomeSettings({ ctx, onClose }: { ctx: HomeContext; onClose: () => void }) {
  return <Modal title="Office settings" description="Make Office feel at home." width={420} onClose={onClose} footer={<SettingsFooter />}>
    <div style={{ display: 'grid', gap: 20 }}>
      <Select label="Appearance" aria-label="Appearance" value={ctx.appearance} options={[{ value: 'system', label: 'Match system' }, { value: 'light', label: 'Light' }, { value: 'dark', label: 'Dark' }]} onChange={(value) => ctx.setAppearance(value as Appearance)} />
      <Select label="File layout" aria-label="File layout" value={ctx.layout} options={[{ value: 'grid', label: 'Grid' }, { value: 'list', label: 'List' }]} onChange={(value) => ctx.setLayout(value as Layout)} />
      <a href={`${accountOrigin()}/account`} target="_blank" rel="noopener noreferrer">Manage account in browser ↗</a>
    </div>
  </Modal>;
}

function SettingsFooter() {
  const close = useModalClose();
  return <Button variant="primary" onClick={close}>Done</Button>;
}
